module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "app-footer"
  }, [_c('div', {
    staticClass: "float-left"
  }, [_vm._v("\n        © " + _vm._s(new Date().getFullYear()) + " Alarm.ru\n        "), _c('a', {
    staticClass: "btn btn-facebook icon btn-sm",
    attrs: {
      "href": "http://www.facebook.com/alarmcenterru",
      "target": "_blank",
      "type": "button"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-vk icon btn-sm",
    attrs: {
      "href": "http://vk.com/alarmru",
      "type": "button",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-youtube icon btn-sm",
    attrs: {
      "href": "https://www.youtube.com/c/AlarmcenterRu?sub_confirmation=1",
      "type": "button",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-instagram icon btn-sm",
    attrs: {
      "href": "https://www.instagram.com/alarm_ru/",
      "type": "button",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-telegram icon btn-sm",
    attrs: {
      "href": "https://t.me/alarmru",
      "type": "button",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://form.asana.com?k=7V8BvVXyrVWqsLOv1fjmhA&d=954381603374797",
      "target": "_blank"
    }
  }, [_vm._v("Замечания и предложения")])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "float-right"
  }, [_c('span', {}, [_vm._v("Отдел продаж   "), _c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" +7 903 724-81-17")]), _c('br'), _vm._v(" "), _c('span', {}, [_vm._v("Техподдержка  "), _c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:anton@alarm.ru"
    }
  }, [_vm._v("anton@alarm.ru")])])])
}]}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/production/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-01f5ee3a"}!/home/alarmplan/production/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 991
// module chunks = 1